import { render } from "./AudioControl.vue?vue&type=template&id=497061b4"
import script from "./AudioControl.vue?vue&type=script&lang=js"
export * from "./AudioControl.vue?vue&type=script&lang=js"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__